var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-card",
        {
          attrs: {
            title: _vm.$t("common.upload-text", {
              text: _vm.$t("lbl_tax_income")
            })
          }
        },
        [
          _c(
            "a-form-model",
            {
              ref: "formModel",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                layout: "vertical",
                "label-col": { span: 6 },
                "wrapper-col": { span: 14 }
              }
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: _vm.$t("lbl_pph_type"), prop: "pphType" } },
                [
                  _c("a-select", {
                    staticClass: "w-100",
                    attrs: {
                      options: _vm.incomeTaxReceivableOptions,
                      "data-testid": "select-tax-pph-type",
                      "label-in-value": "",
                      "show-search": "",
                      "allow-clear": "",
                      placeholder: _vm.$t("common.select-text", {
                        text: _vm.$t("lbl_pph_type")
                      }),
                      "filter-option": false,
                      loading: _vm.loading.taxIncomeTaxReceivable
                    },
                    on: { search: _vm.debouncedSearchTaxIncomeTaxRecevable },
                    model: {
                      value: _vm.form.pphType,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pphType", $$v)
                      },
                      expression: "form.pphType"
                    }
                  })
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { "wrapper-col": { span: 14, offset: 6 } } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.loading.downloadTemplate,
                        "data-testid": "upload-data-download"
                      },
                      on: { click: _vm.downloadTemplate }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("common.download-text", {
                            text: _vm.$t("lbl_template")
                          })
                        ) + " "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: _vm.$t("lbl_upload_file"),
                    help: _vm.$t("lbl_max_upload")
                  }
                },
                [
                  _c(
                    "a-upload-dragger",
                    {
                      attrs: {
                        name: "file",
                        multiple: false,
                        accept: ".xlsx",
                        "before-upload": function() {
                          return false
                        },
                        remove: _vm.handleRemove,
                        "file-list": _vm.fileList,
                        "data-testid": "upload-data-dragger"
                      },
                      on: { change: _vm.handleChange }
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "ant-upload-drag-icon" },
                        [_c("a-icon", { attrs: { type: "inbox" } })],
                        1
                      ),
                      _c("p", { staticClass: "ant-upload-text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("lbl_upload_drag_and_drop")) + " "
                        )
                      ]),
                      _c("p", { staticClass: "ant-upload-hint" }, [
                        _vm._v(" " + _vm._s(_vm.$t("lbl_support_upload")) + " ")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { align: "end" } },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.loading.uploadData,
                            "data-testid": "upload-data-upload"
                          },
                          on: { click: _vm.uploadFile }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("lbl_upload_file")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-card",
        { staticClass: "mt-4", attrs: { title: _vm.$t("lbl_history_upload") } },
        [
          _c(
            "a-row",
            { staticClass: "mb-4" },
            [
              _c(
                "a-col",
                { attrs: { align: "end" } },
                [
                  _c(
                    "a-space",
                    [
                      _c("a-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          options: _vm.incomeTaxReceivableOptions,
                          "data-testid": "select-tax-pph-type",
                          "label-in-value": "",
                          "show-search": "",
                          "allow-clear": "",
                          placeholder: _vm.$t("common.select-text", {
                            text: _vm.$t("lbl_pph_type")
                          }),
                          "filter-option": false,
                          loading: _vm.loading.taxIncomeTaxReceivable
                        },
                        on: {
                          search: _vm.debouncedSearchTaxIncomeTaxRecevable,
                          change: _vm.onChangePphType
                        },
                        model: {
                          value: _vm.filter.pphType,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "pphType", $$v)
                          },
                          expression: "filter.pphType"
                        }
                      }),
                      _c("a-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "allow-clear": "",
                          "data-testid": "filter-status",
                          "label-in-value": "",
                          placeholder: _vm.$t("common.select-text", {
                            text: _vm.$t("lbl_status")
                          }),
                          options: _vm.statusOptions,
                          "show-search": ""
                        },
                        on: { change: _vm.onChangeStatus },
                        model: {
                          value: _vm.filter.status,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "status", $$v)
                          },
                          expression: "filter.status"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              "data-source": _vm.dataHistoryUpload.data,
              columns: _vm.columns,
              loading: _vm.loading.historyUpload,
              pagination: {
                showTotal: function() {
                  return _vm.$t("lbl_total_items", {
                    total: _vm.dataHistoryUpload.totalElements
                  })
                },
                showSizeChanger: true,
                total: _vm.dataHistoryUpload.totalElements,
                pageSizeOptions: _vm.PAGE_SIZE_OPTIONS,
                current: _vm.pagination.page,
                defaultPageSize: _vm.pagination.limit
              },
              "row-class-name": function(_, index) {
                return index % 2 ? "bg-white" : "bg-gray-light"
              },
              size: "small",
              scroll: { y: 600 }
            },
            on: { change: _vm.onTableChange },
            scopedSlots: _vm._u([
              {
                key: "nullable",
                fn: function(text) {
                  return _c("span", {}, [_vm._v(_vm._s(text || "-"))])
                }
              },
              {
                key: "currency",
                fn: function(text) {
                  return _c("span", {}, [
                    _vm._v(_vm._s(_vm._f("currency")(text)))
                  ])
                }
              },
              {
                key: "uploadDate",
                fn: function(text) {
                  return _c("span", {}, [
                    _vm._v(
                      _vm._s(_vm._f("date")(text, _vm.dateTimeDefaultFormat))
                    )
                  ])
                }
              },
              {
                key: "operation",
                fn: function(text, row) {
                  return [
                    _c(
                      "a-dropdown",
                      {
                        attrs: { trigger: ["click"], placement: "bottomCenter" }
                      },
                      [
                        _c("a-button", {
                          attrs: { icon: "bars" },
                          on: {
                            click: function(e) {
                              return e.preventDefault()
                            }
                          }
                        }),
                        _c(
                          "a-menu",
                          {
                            staticClass: "mt-2",
                            attrs: { slot: "overlay" },
                            slot: "overlay"
                          },
                          [
                            _vm.isShowProcess(row)
                              ? _c(
                                  "a-menu-item",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleProcessTaxIncome(
                                          row.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "sync" } }),
                                    _vm._v(_vm._s(_vm.$t("lbl_process")) + " ")
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "a-menu-item",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.handleDownloadTaxIncome(
                                      row.fileOriginal
                                    )
                                  }
                                }
                              },
                              [
                                _c("a-icon", { attrs: { type: "download" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("common.download-text", {
                                        text: _vm.$t("lbl_file_original")
                                      })
                                    ) +
                                    " "
                                )
                              ],
                              1
                            ),
                            _vm.isShowDownloadFailed(row)
                              ? _c(
                                  "a-menu-item",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleDownloadTaxIncome(
                                          row.fileError
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("a-icon", {
                                      attrs: { type: "download" }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("common.download-text", {
                                            text: _vm.$t("lbl_file_error")
                                          })
                                        ) +
                                        " "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }